const boxEndpoint = process.env.REACT_APP_BOX_API;
const accountsEndpoint = process.env.REACT_APP_ACCOUNTS_API;
const userEndpoint = process.env.REACT_APP_USER_API;
const hermesEndpoint = process.env.REACT_APP_HERMES_API;
const aceEndpoint = process.env.REACT_APP_ACE_API;
const cfURL = process.env.REACT_APP_CF_URL;
const envURL = process.env.REACT_APP_ENV_URL;
const originURL = process.env.REACT_APP_ORIGIN_URL;
const erosURL = process.env.REACT_APP_EROS_S3_URL;
const loginVerifyEndpoint = process.env.REACT_APP_LOGIN_VERIFY_API;
const mysteryBoxFilename = process.env.REACT_APP_MYSTERY_BOX_FILENAME;
const ldKey = process.env.REACT_APP_LDKEY;
const sharedBoxParam = process.env.REACT_APP_SHARED_BOX_PARAM;
const questionnaireEndpoint = process.env.REACT_APP_QUESTIONNAIRE_API_URL;

export default {
  box: boxEndpoint,
  accounts: accountsEndpoint,
  user: userEndpoint,
  hermes: hermesEndpoint,
  ace: aceEndpoint,
  cfURL: cfURL,
  envURL: envURL,
  originURL: originURL,
  erosURL: erosURL,
  sharedBoxParam: sharedBoxParam,
  loginVerify: loginVerifyEndpoint,
  mysteryBoxFilename,
  ldKey,
  questionnaire: questionnaireEndpoint,
};



// WEBPACK FOOTER //
// ./src/utils/env.js